import { render, staticRenderFns } from "./CompetitionNews.vue?vue&type=template&id=91161a30&scoped=true"
import script from "./CompetitionNews.vue?vue&type=script&lang=js"
export * from "./CompetitionNews.vue?vue&type=script&lang=js"
import style0 from "./CompetitionNews.vue?vue&type=style&index=0&id=91161a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91161a30",
  null
  
)

export default component.exports